import { DayApi } from "../../Types/Generated/LogbookApi/DayApi"
import { IStoredCalculationSource } from "../../Types/Generated/LogbookModel/StoredCalculation"
import { entity } from "./Connection"
import { applyCalculationResults, calculationFolds, calculationProjectionFields, notableFolds } from "./Folds"

// TripView's Day slice (#1612, tracker #665): one typed days.list request carries
// the days plus their notes/attachments. Calculation results are projected onto the
// fetched base rows; subsequent StoredCalculation broadcasts override them through
// the opt-in fold.
export const DayEntity = entity("Day", {
  sort: (a, b) => a.day - b.day,
  preserveLive: calculationProjectionFields,
  fetch: (client, ids) => {
    const { shipId, tripId } = ids;
    if (shipId === undefined || tripId === undefined) {
      return Promise.reject(new Error("Day fetch requires shipId and tripId"));
    }
    return new DayApi(client).days.list({ params: { shipId, tripId } }).call().then((response) => ({
      entities: {
        Day: applyCalculationResults(
          response.days ?? [],
          response.calculations ?? [],
          response.calculationsV2 ?? [],
        ),
        Note: response.notes ?? [],
        NoteAttachment: response.attachments ?? [],
      },
      extras: { auditLogEdits: response.auditLogEdits ?? [] },
    }));
  },
  folds: {
    ...calculationFolds(IStoredCalculationSource.day),
    ...notableFolds,
  },
});
